import { apiRequest } from "../api.jsx";

export const getCustomerAddresses = () => apiRequest("/profile/addresses");
export const updateCustomerProfile = (profile) =>
  apiRequest("/profile/update", "PUT", profile);
export const uploadCustomerProfileImage = (imageFile) => {
  const formData = new FormData();
  formData.append("profile", imageFile);
  return apiRequest("/profile/update", "PUT", formData);
};
export const addCustomerAddress = (address) =>
  apiRequest("/profile/addresses", "POST", address);
export const updateCustomerAddress = (addressId, address) =>
  apiRequest(`/profile/addresses/${addressId}`, "PUT", address);
export const deleteCustomerAddress = (addressId) =>
  apiRequest(`/profile/addresses/${addressId}`, "DELETE");
export const setDefaultCustomerAddress = (addressId) =>
  apiRequest(`/profile/addresses/default/${addressId}`, "PUT", {});
